import { makeStyles, useTheme, useMediaQuery } from '@material-ui/core';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { STATUS_API, PAGE_SIZE_LIST } from 'src/app/constant/config';
import { getListSim } from 'src/features/simSlice';
import Results from './Results';
import ToolBar from './ToolBar';
import { useQuery } from 'src/app/hooks/useQuery';
import { useNavigate } from 'react-router';
import { _convertObjectToQuery } from 'src/app/utils/apiService';

const ServiceSim = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });

  const {
    statusCreate,
    statusDelete,
    statusUpdate,
    statusDeleteMultiSim,
    statusImport,
    listSims
  } = useSelector(state => state.simSlice);

  const classes = useStyles();
  const query = useQuery();

  const defaultParams = useMemo(
    () => ({
      page: Number(query.get('page')) || 1,
      page_size: isMobile ? 6 : PAGE_SIZE_LIST,
      keywords: query.get('keywords') || undefined
    }),
    [isMobile, query]
  );

  const updateQuery = nextParams => {
    navigate('/app/manage/sim?' + _convertObjectToQuery(nextParams));
  };

  useEffect(() => {
    dispatch(getListSim(defaultParams));
  }, [dispatch, defaultParams]);

  useEffect(() => {
    if (
      statusCreate === STATUS_API.SUCCESS ||
      statusDelete === STATUS_API.SUCCESS ||
      statusUpdate === STATUS_API.SUCCESS ||
      statusDeleteMultiSim === STATUS_API.SUCCESS ||
      statusImport === STATUS_API.SUCCESS
    ) {
      dispatch(getListSim(defaultParams));
    }
  }, [
    statusCreate,
    statusDelete,
    statusUpdate,
    statusDeleteMultiSim,
    statusImport,
    dispatch
  ]);

  return (
    <div className={classes.root}>
      <div style={{ width: '98%', margin: '0 auto' }}>
        <ToolBar searchRef={updateQuery} />
        <Results
          className="mt-3"
          listSims={listSims}
          getListSimRef={updateQuery}
          currentParams={defaultParams}
        />
      </div>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    width: '100%',
    marginTop: 17
  }
}));

export default ServiceSim;
